<template>
    <div class="community-detail">
      <swiper :options="swiperOption" class="swiper-box">
        <swiper-slide class="swiper-item" v-for="img in communityPic" :key="img"><img :src="img" /></swiper-slide>
        <div class="swiper-pagination " slot="pagination"></div>
      </swiper>
      <div class="detail-list">
        <div class="detail-item">
          <img class="community-logo" :src="logo" alt="">
          <span class="community-name">{{communityName}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-item-value">{{tel}}</span>
          <a class="detail-btn" v-if="tel" :href="'tel:' + tel">咨询<img src="../assets/image/consult_icon_black@2x.png" height="32" width="32" alt=""></a>
        </div>
        <div class="detail-item">
          <span class="detail-item-value">{{address}}</span>
          <span class="detail-btn" v-if="address">导航<img src="../assets/image/navigation_icon_black@2x.png" alt="">
          </span>
        </div>
      </div>
      <div class="community-detail-article">
        <div v-html="content"></div>
      </div>
    </div>
</template>

<script>
import api from '@/script/util'
import { swiper, swiperSlide, swiperPlugins } from 'vue-awesome-swiper'
import '@/style/base.css'
var u = navigator.userAgent
if (u.indexOf('Android') === -1) {
  var WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
  document.documentElement.appendChild(WVJBIframe)
}
export default {
  name: '', // 小镇地图
  components: {
    swiper,
    swiperSlide,
    swiperPlugins
  },
  data () {
    return {
      communityPic: [],
      swiperOption: {
        // 如果你后续需要找到当前实例化后的swiper对象以对其进行一些操作的话，可以自定义配置一个名字
        name: 'currentSwiper',
        // 所有配置均为可选（同Swiper配置）
        autoplay: false,
        height: 280,
        direction: 'horizontal',
        pagination: '.swiper-pagination',
        // paginationType: 'fraction',
        paginationClickable: true,

        mousewheelControl: true,
        observeParents: true
        // more Swiper config ...
        // ...
      },
      logo: '',
      communityName: '',
      tel: '',
      address: '',
      longitude: '',
      latitude: '',
      content: ''
    }
  },
  created: function () {
    document.title = '项目介绍'
    let params = {
      communityId: api.getVal('communityId')
    }
    api.GetCommunityDetail(params)
      .then(res => {
        let communityPic = []
        res.annex.forEach(function (item) {
          communityPic.push(item.urlPath)
        })
        this.communityPic = communityPic
        this.logo = res.communityPic
        this.communityName = res.communityName
        this.tel = res.communityPhone
        this.address = res.communityAddress
        this.latitude = res.latitude
        this.longitude = res.longitude
        this.content = res.communityRemark
      })
  },
  methods: {
    mapNav: function () {
      // eslint-disable
      if (u.indexOf('Android') > -1) {
        UamaJSBridge._app_mapNav(this.longitude, this.latitude)
      } else {
        if (window.WebViewJavascriptBridge) {
          window.WebViewJavascriptBridge.callHandler('_app_mapNav', { 'longitude': this.longitude, 'latitude': this.latitude })
        }
      }
    }
  }
}
</script>

<style>
  img{
    max-width: 100%;
  }
</style>

<style scoped>
  .community-detail{
    height:100%;
  }
  .detail-list{
    padding:0 0.64rem;
    background-color:#fff;
  }
  .detail-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.64rem 0;
    border-top: 1px solid #d8d8d8;
    line-height: 1.024rem;
  }
  .detail-item:first-child{
    display:block;
    border-top: none;
  }
  .detail-item-value{
    padding-right:2.176rem;
    font-size:0.64rem;
  }
  .community-logo{
    width: 1.706rem;
    height: 1.706rem;
    border-radius: 50%;
    margin-right: 0.2133rem;
    vertical-align: middle;
  }
  .community-name{
    font-size:0.768rem;
    font-weight:bold;
  }
  .detail-btn{
    display:inline-block;
    flex:0 0 2.56rem;
    width:2.56rem;
    height:1.024rem;
    padding-left:0.298rem;
    border:1px solid #333;
    box-sizing: border-box;
    border-radius: 3px;
    font-size:0.64rem;
  }
  .detail-btn img{
    width: 0.512rem;
    height: 0.512rem;
    margin-left: 0.2rem;
  }
  .community-detail-article{
    padding:0.64rem;
    margin-top:0.426rem;
    font-size:0.64rem;
    background-color:#fff;
  }
</style>



// WEBPACK FOOTER //
// communityDetail.vue?11d7135e